import yotaMarquee from './_yotaMarquee';
//const throttle = require('lodash.throttle');

export function marquee() {
  yotaMarquee.init({
    selector: '.js-marquee'
  });
}